module.exports = __webpack_public_path__ + "img/pulmonology.440e531e.png";